import React from 'react';
import { Link } from 'react-router-dom';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

/* eslint-disable react/prop-types */
const customersActions = ({ permissions }) => ({
  id: 'action-column',
  Header: <span className="expand-header-offset">View</span>,
  Cell: ({ row }) => (
    <div className="form-action-btn-group">
      { AccessControl.hasPermission(permissions,
        [ActivityPerms.customerPageEdit, ActivityPerms.customerPageView]) && <Link to={ `/customer/${ row.original.itemId }` }>
          <button
            type="button"
            className="btn btn-sm btn-sm"
            title="Customer Details"
          >
            <span className="icon icon-apps" />
          </button>
        </Link>}
    </div>
  )
});
/* eslint-enable react/prop-types */

export default customersActions;
